module.exports = __webpack_public_path__ + "static/media/Home Page_website-10.9b42c2db.png";